import { render, staticRenderFns } from "./EditRegionModal.vue?vue&type=template&id=16af00a8"
import script from "./EditRegionModal.vue?vue&type=script&lang=js"
export * from "./EditRegionModal.vue?vue&type=script&lang=js"
import style0 from "./EditRegionModal.vue?vue&type=style&index=0&id=16af00a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports